'use strict'
module.exports = require('./webcrypto-node')
